<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header" style="display: flex; align-items: center; justify-content: space-between;">
        <h3>Company Info</h3>
        <div style="display: flex; align-items: center;">
            <div class="header-button-container">
                @if (!editMode && !editLocked) {
                    <button
                        (click)="edit()"
                        [disabled]="serverAction"
                        [hidden]="!hasEditPermission"
                        class="ace-btn btn-text has-icon btn-primary btn-text my-0">
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                @if (editMode) {
                    <span>
                        <button (click)="save()"
                                [disabled]="infoForm.invalid || serverAction" class="ace-btn btn-text has-icon btn-primary btn-success my-0">
                            <i class="fa fa-save"></i>
                        </button>
                        <button (click)="cancel()" [disabled]="serverAction"
                                class="ace-btn btn-text has-icon btn-primary btn-danger my-0">
                            <i class="fa fa-close"></i>
                        </button>
                    </span>
                }
            </div>
        </div>
    </div>
    <div class="panel-flat-body" [class.large]="enableDynamicCompanyPage">
        @if (serverAction) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        <div [hidden]="serverAction">
            @if (!editMode && enableDynamicCompanyPage) {
                <company-info-panel-view (serverActionChange)="serverAction = $event"
                                         [activatedByPopover]="activatedByPopover"
                                         [company]="company"
                                         [defaultAddress]="defaultAddress"
                                         [parentCompany]="parentCompany">
                </company-info-panel-view>
            } @else if (!editMode && !enableDynamicCompanyPage) {
                <company-info-panel-view-old (serverActionChange)="serverAction = $event"
                                         [activatedByPopover]="activatedByPopover"
                                         [company]="company"
                                         [defaultAddress]="defaultAddress"
                                         [parentCompany]="parentCompany">
                </company-info-panel-view-old>
            }
            @if (editMode) {
                <company-info-panel-edit (serverActionChange)="serverAction = $event"
                                         [activatedByPopover]="activatedByPopover"
                                         [company]="company"
                                         [defaultAddress]="defaultAddress"
                                         [infoForm]="infoForm"
                                         [parentCompany]="parentCompany"
                                         [saveFunc]="saveFunc">
                </company-info-panel-edit>
            }
        </div>
    </div>
</div>

<ng-template #activatedByPopover>
    @if (company.activatedDateTime > company.inactivatedDateTime) {
        <div>
            @if (company.activatedBy) {
                <div>
                    Activated by {{ company.activatedBy }} <br>
                    Date: {{ company.activatedDateTime | date:'shortDate' }}
                </div>
            }
            @if (company.inactivatedBy || company.inactivatedDateTime) {
                <div style="margin-top: 10px;">
                    Inactivated @if (company.inactivatedBy) {
                    <span>by {{ company.inactivatedBy }}</span>
                } <br>
                    Date: {{ company.inactivatedDateTime | date:'shortDate' }}
                </div>
            }
        </div>
    }
    @if (company.activatedDateTime <= company.inactivatedDateTime) {
        <div>
            @if (company.inactivatedBy || company.inactivatedDateTime) {
                <div style="margin-top: 10px;">
                    Inactivated @if (company.inactivatedBy) {
                    <span>by {{ company.inactivatedBy }}</span>
                } <br>
                    Date: {{ company.inactivatedDateTime | date:'shortDate' }}
                </div>
            }
            @if (company.activatedBy) {
                <div>
                    Activated by {{ company.activatedBy }} <br>
                    Date: {{ company.activatedDateTime | date:'shortDate' }}
                </div>
            }
        </div>
    }
</ng-template>
